module.exports = __webpack_public_path__ + "a55c5b929d1827d65c2bdb37350552bc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-16.png
// module id = 1751
// module chunks = 0